import { EarningsInsight } from '@api';
import { SkeletonLoader } from '@design/components/skeleton-loader/SkeletonLoader';
import { PosthogTrackingSource } from '@terminal/services/tracking/posthog/constants';
import { EarningsInsightPill } from '@terminal/widgets/earnings-insight-drawer/earnings-insight-widget/components/earnings-insight-pill/EarningsInsightPill';

interface EarningInsightsCellProps {
  earningsInsight?: EarningsInsight;
  entityTag?: string;
  isFetching: boolean;
  source: PosthogTrackingSource;
}

export const EarningInsightsCell = ({
  earningsInsight,
  entityTag,
  isFetching,
  source,
}: EarningInsightsCellProps) => {
  const hasData = !!earningsInsight && !!entityTag;

  if (isFetching) {
    return (
      <div>
        <SkeletonLoader
          areas={[
            {
              styles: {
                width: '180px',
                height: '25px',
                borderRadius: '8px',
              },
            },
          ]}
        />
      </div>
    );
  }

  return hasData ? (
    <EarningsInsightPill
      entityTag={entityTag}
      earningsInsight={earningsInsight}
      isPreview={earningsInsight?.type === 'preview'}
      source={source}
    />
  ) : null;
};
